<script setup lang="ts">
import MovePageBtn from '@/components/AccountParts/MovePageBtn.vue';
import CopyButton from "@/components/Common/CopyButton.vue";
import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(
  defineProps<{
    copyText: string
    modelValue: boolean
    accountId: string | null
    isLoading: boolean
    isDriverMode: boolean
    roleAssignAuthority: boolean
    update?: (bool: boolean) => void
    changeModalStatus?: (bool: boolean) => void
  }>(),
  {
    copyText: '',
    modelValue: true,
    accountId: null,
    isLoading: false,
    isDriverMode: false
  }
);

const isCopied = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

const isClickedMovePageBtn = ref(false as boolean)

const closeButtonClass = computed(() => {
  return isCopied.value ? 'close-btn' : 'exec-btn'
})

const isDisplayNotAuthorizedMessage = computed(() => {
  return !props.accountId && isClickedMovePageBtn.value && !props.roleAssignAuthority
})
</script>
<template>
  <div class="d-flex w-100 justify-content-end mb-4 pr-6">
    <CopyButton
      v-if="props.isDriverMode"
      :copyText="copyText"
      v-model="isCopied"
    />
    <div>
      <v-btn
        v-if="props.isDriverMode && props.accountId"
        class="close-btn ml-2 exec-btn"
        :loading="props.isLoading"
        :disabled="!isCopied"
        :style="{
          backgroundColor : isCopied ? '' : '#B3B8BB'
        }"
        @click="props.update && props.update(false)"
      >
        {{ i18n.global.t('pages.common.button.conservation') }}
      </v-btn>
      <MovePageBtn
        v-else
        routeName="RoleAssaignment"
        :title="i18n.global.t('pages.accounts.moveRoleAssignDisplayBtn')"
        class="exec-btn ml-2"
        :color="isCopied ? '#1976D2' : '#B3B8BB'"
        :style="{
          color: 'white'
        }"
        :disabled="!isCopied || isClickedMovePageBtn"
        v-model="isClickedMovePageBtn"
        :isMovable="props.roleAssignAuthority"
      />
    </div>
    <div>
      <MovePageBtn
        v-if="!props.accountId"
        routeName="Accounts"
        :title="i18n.global.t('pages.common.button.close')"
        :class="`${closeButtonClass} ml-2`"
        :color="isCopied ? '' : '#B3B8BB'"
        :style="{
          color: '#000000DE',
        }"
        :disabled="!isCopied"
      />
      <v-btn
        v-else
        class="close-btn ml-2"
        :disabled="props.isLoading"
        :style="{
          backgroundColor : props.isLoading ? '#B3B8BB' : ''
        }"
        @click="props.changeModalStatus && props.changeModalStatus(false)"
      >
        {{ i18n.global.t('pages.common.button.close') }}
      </v-btn>
    </div>
  </div>
  <div
    v-if="isDisplayNotAuthorizedMessage"
    class="d-flex justify-content-end mx-2"
  >
    <p style="color: red">{{ i18n.global.t('pages.accounts.notAuthorizedMessage') }}</p>
  </div>
</template>
